<template>
  <div class="widget-accordion-custom">
    <div v-if="showAccordion" class="widget-accordion-content">
      <details v-for="(item, index) in items" :key="index" class="widget-accordion-item" :open="index===0" :style="item.itemStyle || null">
        <summary class="widget-accordion-summary" :style="item.headerStyle || null">
          <div class="widget-accordion-header">
            <div v-html="item.title"></div>
            <b-badge v-if="item.badge" variant="primary">{{ item.badge }}</b-badge>
          </div>
        </summary>
        <div class="widget-accordion-body" v-if="item.body" v-html="item.body" :style="item.bodyStyle || null"></div>
      </details>
    </div>
    <WidgetEmptyState v-else :message="emptyMessage" :variant="data.variant" />
  </div>
</template>

<script>
  import WidgetEmptyState from './WidgetEmptyState'

  export default {
    components: { WidgetEmptyState },
    props: {
      data: {
        type: Object,
        required: true
      },
    },
    data(){
      return {
        items: [],
        showAccordion: false,
      }
    },
    mounted() {
      this.configureData()
    },
    watch: {
      data: {
        handler: function(){
          this.configureData()
        },
        deep: true,
      },
    },
    computed: {
      emptyMessage() {
        if(typeof this.data.items === 'string') return this.data.items
        if(Array.isArray(this.data.items) && this.data.items.length === 0) {
          return 'No hay registros para mostrar.'
        }
        return 'No hay datos para mostrar.'
      },
    },
    methods: {
      configureData() {
        if(!Array.isArray(this.data.items) || this.data.items.length === 0) {
          this.showAccordion = false
          this.items = []
        } else {
          this.showAccordion = true
          this.items = this.data.items
        }
      },
    }
  }
</script>

<style>
  .widget-accordion-custom {
    height: 100%;
    min-height: 0;
    overflow: visible;
  }
  .widget-accordion-content {
    display: grid;
    gap: 8px;
    padding: 0;
  }
  .widget-accordion-item {
    overflow: hidden;
    margin: 0;
    border: 1px solid var(--app-color-border);
    border-radius: 9px;
    background: var(--app-color-surface);
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }
  .widget-accordion-item[open] {
    border-color: var(--app-color-primary-200);
    box-shadow: var(--app-shadow-sm);
  }
  .widget-accordion-summary {
    display: block;
    list-style: none;
    cursor: pointer;
    padding: 10px 12px;
    color: var(--app-color-text);
    font-size: var(--app-text-sm);
    font-weight: var(--app-font-medium);
    transition: background-color 0.15s ease, color 0.15s ease;
  }
  .widget-accordion-summary:hover,
  .widget-accordion-summary:focus {
    outline: none;
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary-active);
  }
  .widget-accordion-item[open] .widget-accordion-summary {
    border-bottom: 1px solid var(--app-color-border);
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary-active);
  }
  .widget-accordion-summary::-webkit-details-marker {
    display: none;
  }
  .widget-accordion-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }
  .widget-accordion-body {
    padding: 10px 12px;
    color: var(--app-color-text-secondary);
    background: var(--app-color-surface-subtle);
    font-size: var(--app-text-sm);
    line-height: var(--app-leading-default);
  }
</style>
